import * as React from 'react';

import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import { cva } from 'class-variance-authority';

import { cn } from '../lib/utils';

const HoverCard = HoverCardPrimitive.Root;
const HoverCardTrigger = HoverCardPrimitive.Trigger;
const HoverCardPortal = HoverCardPrimitive.Portal;

const hoverCardVariants = cva(
  'vai-z-50 vai-w-64 vai-rounded-md vai-p-4 vai-shadow-md vai-outline-none data-[state=open]:vai-animate-in data-[state=closed]:vai-animate-out data-[state=closed]:vai-fade-out-0 data-[state=open]:vai-fade-in-0 data-[state=closed]:vai-zoom-out-95 data-[state=open]:vai-zoom-in-95 data-[side=bottom]:vai-slide-in-from-top-2 data-[side=left]:vai-slide-in-from-right-2 data-[side=right]:vai-slide-in-from-left-2 data-[side=top]:vai-slide-in-from-bottom-2',
  {
    variants: {
      variant: {
        default: 'vai-border vai-bg-popover vai-text-popover-foreground',
        primary: 'vai-border-sapphire-600 vai-bg-sapphire-600 vai-text-white',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content> & {
    variant?: 'default' | 'primary';
  }
>(
  (
    {
      className,
      align = 'center',
      sideOffset = 4,
      variant = 'default',
      ...props
    },
    ref,
  ) => (
    <HoverCardPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(hoverCardVariants({ variant }), className)}
      {...props}
    />
  ),
);
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

export { HoverCard, HoverCardTrigger, HoverCardContent, HoverCardPortal };
